/* eslint-disable no-return-await */

import qs from 'qs';
import _ from 'underscore';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminConstants from '../constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import client from './rest/AdminClient';

const Actions = AdminConstants.ActionTypes;

const nearbyDriversQuery = {
  select: 'first_name last_name phone carrier equipment_class coords available',
  populate: [
    {
      path: 'carrier',
      select: 'name',
    },
  ],
  paginate: true,
  authorized: true,
  per_page: 200,
};

export function getAuthorizedDrivers(id) {
  return client({
    method: 'GET',
    path: `api/1/carriers/${id}/drivers/authorized`,
    params: {
      _: new Date().getTime(),
    },
  });
}

function getAvailableDrivers(props = {}) {
  return client({
    method: 'GET',
    path: `/api/1/${props.id}/drivers/available`,
  });
}

function getNearbyDrivers(id, params = {}, options = {}) {
  const query = _.extend(nearbyDriversQuery, params, options);
  const queryString = qs.stringify(query);

  return client({
    method: 'GET',
    path: `api/v2/drivers/${id}?${queryString}`,
    params: {
      _: new Date().getTime(),
    },
  });
}

function getAllDrivers(id) {
  return client({
    method: 'GET',
    path: `api/1/carriers/${id}/drivers?q=${new Date().toJSON()}`,
  });
}

function toggleAuthorization({ driver_id, status }) {
  return client({
    method: 'PUT',
    path: 'api/1/drivers/authorization',
    entity: JSON.stringify({
      driver_id,
      status,
    }),
  });
}

function toggleReceiveOffers({ driver_id, status }) {
  return client({
    method: 'PUT',
    path: 'api/1/drivers/receive',
    entity: JSON.stringify({
      driver_id,
      status,
    }),
  });
}

function toggleMultiplePickup({ driver_id, status }) {
  return client({
    method: 'PUT',
    path: 'api/1/drivers/multiple-pickup',
    entity: JSON.stringify({
      driver_id,
      status,
    }),
  });
}

function acceptOffer({ offerId, driverId }) {
  return client({
    method: 'PUT',
    path: '/api/1/offers/accept',
    entity: JSON.stringify({
      offer_id: offerId,
      driver_id: driverId,
      accept: true,
      by_proxy: true,
    }),
  });
}

const getDriverById = (id) => {
  return client({
    method: 'GET',
    path: `api/1/drivers/${id}`,
  });
};

const addDriverComment = (id, comment) => {
  return client({
    method: 'POST',
    path: `/admin/api/v2/carriers/${id}/comment`,
    entity: JSON.stringify({ comment }),
  });
};

const DriverWebAPIUtils = {
  getAuthorizedDrivers(id) {
    getAuthorizedDrivers(id).then(
      (response) => {
        AdminServerActionCreators.receiveAuthorizedDriversSuccess(
          response.entity.drivers,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getAvailableDrivers(props) {
    getAvailableDrivers(props).then(
      (response) => {
        AdminServerActionCreators.receiveAvailableDriversSuccess(
          response.entity.data,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getNearbyDrivers(id, query) {
    getNearbyDrivers(id, query).then(
      (response) => {
        AdminServerActionCreators.receiveNearbyDriversForCarrierSuccess(
          response.entity.data,
          response.entity.meta.count,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getAllDrivers(id) {
    getAllDrivers(id).then(
      // get signed urls for profile picture
      (response) =>
        AdminServerActionCreators.receiveDriversSuccess(
          response.entity.drivers,
        ),
      (response) => console.error(response),
    );
  },
  toggleAuthorization({ driver_id, status }) {
    toggleAuthorization({ driver_id, status }).then(
      () =>
        AdminServerActionCreators.toggleDriverAuthorizationSuccess({
          driver_id,
          status,
        }),
      (response) => console.error(response),
    );
  },
  toggleReceiveOffers({ driver_id, status }) {
    toggleReceiveOffers({ driver_id, status }).then(
      () =>
        AdminServerActionCreators.toggleReceiveOffersSuccess({
          driver_id,
          status,
        }),
      (response) => console.error(response),
    );
  },
  toggleMultiplePickup({ driver_id, status }) {
    toggleMultiplePickup({ driver_id, status }).then(
      () =>
        AdminServerActionCreators.toggleMultiplePickupSuccess({
          driver_id,
          status,
        }),
      (response) => console.error(response),
    );
  },
  acceptOffer(props) {
    acceptOffer(props).then(
      (response) => {
        const {
          entity: { success, error },
        } = response;
        if (success) {
          AdminServerActionCreators.acceptOfferSuccess(props);
        } else {
          AdminServerActionCreators.acceptOfferSuccess({
            ...props,
            error,
          });
        }
      },
      (response) => {
        const {
          entity: { success, error },
        } = response;
        AdminServerActionCreators.acceptOfferFail({
          ...props,
          error,
          success,
        });
      },
    );
  },
  async getDriverById(id) {
    return await getDriverById(id).then(
      (response) => {
        return response.entity;
      },
      (error) => {
        throw error;
      },
    );
  },
  async addDriverComment(id, comment) {
    return await addDriverComment(id, comment).then(
      (response) => {
        const carrier = response.entity.data;
        AdminServerActionCreators.updatedCarrier(carrier._id, carrier);
      },
      (error) => {
        throw error;
      },
    );
  },
};

AdminAppDispatcher.register((payload) => {
  const driverId = payload.action.driverId;
  const offerId = payload.action.offerId;
  switch (payload.action.type) {
    case Actions.ACCEPT_OFFER_REQUEST:
      DriverWebAPIUtils.acceptOffer({ driverId, offerId });
      break;
    default:
  }
});

export default DriverWebAPIUtils;
